const Equipment = () => {
  return (
    <svg
      width="21"
      height="23"
      viewBox="0 0 21 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 21.5H10.25M9.25 5.75204C9.88924 5.58751 10.5594 5.5 11.25 5.5C15.6683 5.5 19.25 9.08172 19.25 13.5C19.25 16.8574 17.1818 19.7317 14.25 20.9185M3.75 12.5H7.75C8.21466 12.5 8.44698 12.5 8.64018 12.5384C9.43356 12.6962 10.0538 13.3164 10.2116 14.1098C10.25 14.303 10.25 14.5353 10.25 15C10.25 15.4647 10.25 15.697 10.2116 15.8902C10.0538 16.6836 9.43356 17.3038 8.64018 17.4616C8.44698 17.5 8.21466 17.5 7.75 17.5H3.75C3.28534 17.5 3.05302 17.5 2.85982 17.4616C2.06644 17.3038 1.44624 16.6836 1.28843 15.8902C1.25 15.697 1.25 15.4647 1.25 15C1.25 14.5353 1.25 14.303 1.28843 14.1098C1.44624 13.3164 2.06644 12.6962 2.85982 12.5384C3.05302 12.5 3.28534 12.5 3.75 12.5ZM2.25 5V12.5H9.25V5C9.25 3.067 7.683 1.5 5.75 1.5C3.817 1.5 2.25 3.067 2.25 5Z"
        stroke="#6CB6E3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Equipment